import React, { useState, useEffect } from "react";
import "../styles/wtwsystem.scss";


const WTWsystemen = () => {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  useEffect(() => {
    document.title = 'WTW Systemen - Fresh Air Care';
  }, []);

    return (
    <div className="wtw-page">
      {/* ========== HERO ========== */}
      <section className="wtw-hero">
        <div className="wtw-container">
          <div className="wtw-hero-content">
            <div className="wtw-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
              WTW Systemen
            </div>
            <h1 className="wtw-hero-title">
              Warmte behouden, <span className="wtw-accent">energie besparen</span>
            </h1>
            <p className="wtw-hero-description">
              Professionele installatie en onderhoud voor optimale warmteterugwinning en een gezond binnenklimaat.
            </p>
            <div className="wtw-cta-row">
              <a href="#contact" className="cta-primary1" onClick={() => window.location.href = '#contact'}>
                Gratis Advies
              </a>
              <a href="/tarieven" className="cta-secondary1" onClick={() => window.location.href = '/tarieven'}>
                Bekijk Tarieven
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ========== INTRO TEXT SECTION ========== */}
      <section className="wtw-section wtw-intro-section">
        <div className="wtw-container">
          <div className="wtw-intro-content">
            <h2 className="wtw-intro-title">Continue ventilatie met warmtebehoud</h2>
            <p className="wtw-intro-text">
              Een WTW-systeem zorgt voor verse lucht zonder warmteverlies. Vochtige lucht uit keuken, badkamer en toilet wordt afgevoerd, terwijl verse buitenlucht wordt aangevoerd. De warmtewisselaar houdt de warmte binnen – goed voor je binnenklimaat én energierekening.
            </p>
          </div>

          <div className="wtw-services-grid">
            <div className="wtw-service-card">
              <div className="wtw-service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Installatie</h3>
              <p>Energiezuinige WTW-systemen vakkundig geïnstalleerd</p>
            </div>

            <div className="wtw-service-card">
              <div className="wtw-service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                  <path d="M12 17L7 12L8.41 10.59L11 13.17V7H13V13.17L15.59 10.59L17 12L12 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Vervanging</h3>
              <p>Oude units vervangen door moderne, stille modellen</p>
            </div>

            <div className="wtw-service-card">
              <div className="wtw-service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Inspectie</h3>
              <p>Fijnregeling van luchtstromen en rendement</p>
            </div>

            <div className="wtw-service-card">
              <div className="wtw-service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Reiniging</h3>
              <p>Kanalen, filters en warmtewisselaar grondig gereinigd</p>
            </div>

            <div className="wtw-service-card">
              <div className="wtw-service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Onderhoud</h3>
              <p>Periodieke controle voor blijvende prestaties</p>
            </div>
          </div>

          <p className="wtw-intro-footer">
            Renovatie of nieuwbouw, wij zorgen voor frisse, warme lucht zonder energieverlies.
          </p>
        </div>
      </section>

      {/* ========== EFFICIENCY COMPARISON ========== */}
      <section className="wtw-section wtw-efficiency">
        <div className="wtw-container">
          <div className="wtw-section-header">
            <h2 className="wtw-section-title">Energiebesparing bij nieuw systeem</h2>
            <p className="wtw-section-description">
              Ontdek hoeveel je bespaart met een modern WTW-systeem
            </p>
          </div>
          
          <div className="wtw-comparison-grid">
            <div className="wtw-comparison-card wtw-traditional">
              <div className="wtw-card-header">
                <h3>Oud systeem</h3>
                <div className="wtw-efficiency-badge">60% efficiënt</div>
              </div>
              <div className="wtw-stats">
                <div className="wtw-stat">
                  <span className="wtw-stat-value">€500</span>
                  <span className="wtw-stat-label">Jaarlijkse energiekosten</span>
                </div>
                <div className="wtw-stat">
                  <span className="wtw-stat-value">40%</span>
                  <span className="wtw-stat-label">Warmteverlies</span>
                </div>
                <div className="wtw-stat">
                  <span className="wtw-stat-value">Hoog</span>
                  <span className="wtw-stat-label">Energieverbruik</span>
                </div>
              </div>
            </div>
            
            <div className="wtw-comparison-card wtw-wtw">
              <div className="wtw-card-header">
                <h3>Nieuw WTW systeem</h3>
                <div className="wtw-efficiency-badge wtw-efficient">95% efficiënt</div>
              </div>
              <div className="wtw-stats">
                <div className="wtw-stat">
                  <span className="wtw-stat-value">€150</span>
                  <span className="wtw-stat-label">Jaarlijkse energiekosten</span>
                </div>
                <div className="wtw-stat">
                  <span className="wtw-stat-value">5%</span>
                  <span className="wtw-stat-label">Warmteverlies</span>
                </div>
                <div className="wtw-stat">
                  <span className="wtw-stat-value">€350</span>
                  <span className="wtw-stat-label">Besparing per jaar</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== FILTER MANAGEMENT ========== */}
      <section className="wtw-section wtw-section-dark" id="filters">
        <div className="wtw-container">
          <div className="wtw-section-header">
            <h2 className="wtw-section-title">Professioneel onderhoud</h2>
            <p className="wtw-section-description">
              Regelmatig onderhoud voor optimale prestaties en lange levensduur
            </p>
          </div>

          <div className="wtw-filter-types">
            <div className="wtw-filter-card">
              <div className="wtw-filter-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Filters vervangen</h3>
              <p>Verse lucht begint met schone filters</p>
              <div className="wtw-filter-lifespan">Elke 3-6 maanden</div>
            </div>
            
            <div className="wtw-filter-card">
              <div className="wtw-filter-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Warmtewisselaar</h3>
              <p>Reinigen voor maximaal rendement</p>
              <div className="wtw-filter-lifespan">Jaarlijks</div>
            </div>
            
            <div className="wtw-filter-card">
              <div className="wtw-filter-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Kanalen reinigen</h3>
              <p>Grondige reiniging voor hygiëne</p>
              <div className="wtw-filter-lifespan">Elke 3-5 jaar</div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== VERVANGEN ========== */}
      <section className="wtw-section" id="vervangen">
        <div className="wtw-container">
          <div className="wtw-section-header">
            <h2 className="wtw-section-title">Wanneer vervangen?</h2>
            <p className="wtw-section-description">
              Moderne WTW-systemen zijn stiller, efficiënter en besparen meer energie
            </p>
          </div>

          <div className="wtw-replacement-grid">
            <div className="wtw-replacement-card wtw-replacement-card-warning">
              <div className="wtw-replacement-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L19 7L14.74 12L19 17L13.09 15.74L12 22L10.91 15.74L5 17L9.26 12L5 7L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Oud systeem</h3>
              <p>Ouder dan 15-20 jaar</p>
            </div>
            <div className="wtw-replacement-card wtw-replacement-card-warning">
              <div className="wtw-replacement-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Laag rendement</h3>
              <p>Warmteterugwinning onder 70%</p>
            </div>
            <div className="wtw-replacement-card wtw-replacement-card-warning">
              <div className="wtw-replacement-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Te veel geluid</h3>
              <p>Bromtonen of trillingen in het systeem</p>
            </div>
          </div>

          <div className="wtw-cta-row wtw-cta-center">
            <a href="#contact" className="cta-primary1" onClick={() => window.location.href = '#contact'}>
              Offerte Aanvragen
            </a>
            <a href="/tarieven" className="cta-secondary1 light" onClick={() => window.location.href = '/tarieven'}>
              Bekijk Tarieven
            </a>
          </div>
        </div>
      </section>

      {/* ========== FAQ ========== */}
      <section className="wtw-section wtw-section-light">
        <div className="wtw-container">
          <div className="wtw-section-header">
            <h2 className="wtw-section-title">Veelgestelde vragen</h2>
            <p className="wtw-section-description">
              Alles wat je moet weten over WTW-systemen onderhoud en vervanging
            </p>
          </div>

          <div className="wtw-faq-grid">
            {[
              {
                q: "Wat is het verschil tussen WTW en mechanische ventilatie?",
                a: "WTW wint warmte terug uit afgevoerde lucht (tot 95%), terwijl mechanische ventilatie alleen afvoert. WTW bespaart veel meer energie en geeft comfort zonder warmteverlies.",
              },
              {
                q: "Hoe vaak moet ik de filters vervangen?",
                a: "Gemiddeld elke 3 tot 6 maanden, afhankelijk van de omgeving en het type filter. In stofrijke omgevingen of bij veel verkeer is vaker vervangen aan te raden.",
              },
              {
                q: "Kan ik de filters zelf vervangen?",
                a: "Ja, het is meestal eenvoudig zelf te doen. Raadpleeg altijd de handleiding van uw systeem. Wij kunnen u ook adviseren of helpen bij het vervangen van filters.",
              },
              {
                q: "Hoe lang gaat een WTW-systeem mee?",
                a: "Bij goed onderhoud kan een WTW-systeem 15 tot 20 jaar meegaan. Regelmatig onderhoud is essentieel voor een lange levensduur en optimale prestaties.",
              },
              {
                q: "Hoeveel bespaar ik met een nieuw WTW-systeem?",
                a: "Een modern WTW-systeem kan tot €350 per jaar besparen op energiekosten. Door 95% warmteterugwinning verbruik je veel minder energie voor verwarming.",
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`wtw-faq-card ${open === i ? "open" : ""}`}
                onClick={() => toggle(i)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => (e.key === "Enter" ? toggle(i) : null)}
              >
                <div className="wtw-faq-question">
                  {item.q}
                  <span className="wtw-faq-icon">{open === i ? "−" : "+"}</span>
                </div>
                {open === i && <div className="wtw-faq-answer">{item.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

        </div>
    );
};

export default WTWsystemen;
